import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CalendarInput from './CalendarInput';
import ActionCalendarContainer from './ActionCalendarContainer';
import { ja } from 'date-fns/locale';
import { YMD_OUTPUT_FORMAT } from '../../constants/calender';
import { format } from 'date-fns';

registerLocale('ja', ja);

interface YmdPickerProps {
  placeholder?: string;
  className?: string;
  selectedDate: Date | null;
  setSelectedDate: (pickedDate: Date | null) => void;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const YmdPicker = ({
  placeholder = '日付を選択',
  className,
  selectedDate,
  setSelectedDate,
  ref,
  onKeyDown,
}: YmdPickerProps) => {
  const [open, setOpen] = useState(false);
  // カレンダー上で選択中の日付
  const [pickedDate, setPickedDate] = useState<Date | null>(selectedDate);

  const handleOk = () => {
    setOpen(false);
    setSelectedDate(pickedDate);
  };

  return (
    <div className="d-flex">
      <DatePicker
        selected={selectedDate}
        onChange={(d: Date | null) => setPickedDate(d)}
        dateFormat={YMD_OUTPUT_FORMAT}
        locale="ja"
        open={open}
        formatWeekDay={(name) => {
          const map: Record<string, string> = {
            日: 'S',
            日曜: 'S',
            日曜日: 'S',
            月: 'M',
            月曜: 'M',
            月曜日: 'M',
            Mon: 'M',
            Monday: 'M',
            火: 'T',
            火曜: 'T',
            火曜日: 'T',
            Tue: 'T',
            Tues: 'T',
            Tuesday: 'T',
            水: 'W',
            水曜: 'W',
            水曜日: 'W',
            Wed: 'W',
            Wednesday: 'W',
            木: 'T',
            木曜: 'T',
            木曜日: 'T',
            Thu: 'T',
            Thursday: 'T',
            金: 'F',
            金曜: 'F',
            金曜日: 'F',
            Fri: 'F',
            Friday: 'F',
            土: 'S',
            土曜: 'S',
            土曜日: 'S',
            Sat: 'S',
            Saturday: 'S',
          };
          return map[name];
        }}
        shouldCloseOnSelect={false}
        onClickOutside={() => setOpen(false)}
        onInputClick={() => setOpen(true)}
        popperPlacement="bottom-start"
        portalId="root"
        placeholderText={placeholder}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="rdp-header">
            <button
              type="button"
              className="react-datepicker__navigation react-datepicker__navigation--previous"
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
                ‹
              </span>
            </button>

            <div className="rdp-header-label">{format(date, 'yyyy年M月')}</div>

            <button
              type="button"
              className="react-datepicker__navigation react-datepicker__navigation--next"
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
                ›
              </span>
            </button>
          </div>
        )}
        customInput={
          <CalendarInput
            value={selectedDate ? format(selectedDate, 'yyyy/MM/dd') : ''}
            placeholder={placeholder}
            onClick={() => setOpen(true)}
          />
        }
        calendarContainer={(p) => (
          <ActionCalendarContainer
            {...p}
            onOk={handleOk}
            onCancel={() => setOpen(false)}
          >
            {p.children}
          </ActionCalendarContainer>
        )}
        className={`form-control text-center ${className ?? ''}`}
      />
      <button
        className="input-group-text"
        onClick={() => setOpen(true)}
        ref={ref}
        onKeyDown={onKeyDown}
      >
        📅
      </button>
    </div>
  );
};

export default YmdPicker;
